<template>
  <div class="pt-4" v-if="$store.getters.isAdmin">
    <div>Admin only:</div>

    <div class="mt-2">
      <div class="input-group mb-3 w-50">
        <b-form-select v-model="selected" :options="groups"></b-form-select>

        <button
          type="button"
          class="btn btn-primary ml-2"
          @click="loadSpecificUnits"
        >
          Load
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "AdminGetUnits",
  data() {
    return {
      selected: null,
      selectuserId: null,
       groups: [],
    };
  },
  computed: {},
  methods: {
    loadSpecificUnits() {
      this.$emit("loadSpecificUnits", this.selected);
    },
    async getGroups() {
      let result = await api.groups.getGroups();

      let { error, message, results } = result;

      if (error) {
        console.error(message);
        return;
      }

      this.groups = results.groups;

      for (let i = 0; i < results.groups.length; i++) {
        this.groups[i] = {
          'value': results.groups[i].groupName,
          'text': results.groups[i].groupName,
        };
      }
    },
  },
  beforeMount() {
    this.getGroups();
  },
};
</script>
